<main class="panel-viewport">
  @switch (currentPane) {

    @case ('left') {
  <section leftPane>
    <button mat-stroked-button (click)="onCloseClick()">Close</button>
    @let product1 = currentP$ | async;
    @if (product1) {
      <span><update-product-form  [product]="product1"></update-product-form ></span>
    }

  </section>
}
    @case ('center') {
  <section centerPane>
    <h2>Product List</h2>
    @if (loading) {
      <mat-progress-spinner mode="indeterminate" [diameter]="30" class='spin'> </mat-progress-spinner>
    }
    <table mat-table [dataSource]="dataSource" matSort>

      <ng-container matColumnDef="update">
        <th mat-header-cell *matHeaderCellDef> Update</th>
        <td mat-cell *matCellDef="let element">@if (element.program!= '') {
          <span><button mat-flat-button color="primary" (click)="onClickUpdate(element)">Update</button></span>
        }</td>
      </ng-container>

      <ng-container matColumnDef="wooid">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Woo Id</th>
        <td mat-cell *matCellDef="let element">{{element.externalid}} </td>
      </ng-container>
      <ng-container matColumnDef="product">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="title"> Product</th>
        <td mat-cell *matCellDef="let element"> {{element.title}} </td>
      </ng-container>
      <ng-container matColumnDef="categories" >
        <th mat-header-cell *matHeaderCellDef mat-sort-header="category"> Categories</th>
        <td mat-cell *matCellDef="let element"> {{element.category}} </td>
      </ng-container>
      <ng-container matColumnDef="sku">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> SKU</th>
        <td mat-cell *matCellDef="let element" > {{element.sku}} </td>
      </ng-container>
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Status</th>
        <td mat-cell *matCellDef="let element" > {{element.status}} </td>
      </ng-container>
      <ng-container matColumnDef="price">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Price</th>
        <td mat-cell *matCellDef="let element">${{element.price | number:'1.2-2'}} </td>
      </ng-container>
      <ng-container matColumnDef="assign">
        <th mat-header-cell *matHeaderCellDef> Assign</th>
        <td mat-cell *matCellDef="let element">
          @if (isAdmin()) {
            <span>
              <button mat-flat-button color="primary" name="xferbutton" (click)="onClickAssign(element)"> Assign </button>
            </span>
          }</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

      </table>
      <mat-paginator   [pageSize]="pageSize" [pageSizeOptions]="[5, 10, 15, 20, 50, 100]">
      </mat-paginator>

    </section>
  }
    @case ('right') {
    <section rightPane>
      <button mat-stroked-button (click)="onCloseClick()">Close</button>
      @if (product1) {
        <span><assign-product-form  [product]="product1"></assign-product-form ></span>
      }

    </section>
    }
  }
</main>
